module.exports = __webpack_public_path__ + "img/proj-2.d193c6c8.png";